import { selectorFamily } from 'recoil';
import {
  getCart as apiGetCart,
  getMerchantName as apiGetMerchantName,
  getLogotype as apiGetLogotype
} from '../service/checkoutApi';

export const getCart = selectorFamily({
  key: 'getCart',
  get: id => async () => {
    return apiGetCart(id);
  }
});

export const getMerchantName = selectorFamily({
  key: 'getMerchantName',
  get: id => async () => {
    return apiGetMerchantName(id);
  }
});

export const getLogotype = selectorFamily({
  key: 'getLogotype',
  get: id => async () => {
    return apiGetLogotype(id);
  }
});
